const shape = {
    borderRadius: 2,
    borderRadiusSm: 12,
    borderRadiusMd: 16
};
  
export default shape;